import gsap from 'gsap';

export class Marquee {
  constructor() {
    this.els = document.querySelectorAll('[data-marquee]');
    this.tweens = [];
    this.reset();
    this.setup();
  }

  reset() {
    this.els = document.querySelectorAll('[data-marquee]');
    this.els.forEach((el) => {
      gsap.set(el, { x: '0%' });
    });
  }

  setup(els = this.els) {
    els.forEach((el) => {
      gsap.set(el, { x: '0%' });
      const { scrollDuration, scrollEase } = el.dataset;

      let tween = gsap.timeline({
        defaults: {
          duration: scrollDuration || 20,
          ease: scrollEase || 'linear',
          repeat: -1,
        },
      });

      // card animation
      // const marquee_animations = this.setCard(el);
      // tween.add(marquee_animations, 0);
      tween.fromTo(
        el,
        {
          x: '0%',
        },
        {
          x: '-84.2%',
        }
      );

      this.tweens.push(tween);
    });
  }

  setCard(el) {
    let animations_list = [];
    const { scrollDelay, scrollDuration, scrollEase, scrollGroup, scrollX } =
      el.dataset;
    const animation = gsap.fromTo(
      el,
      {
        opacity: 0,
        blur: 5,
        y: '30%',
        x: scrollX || '40%',
      },
      {
        opacity: 1,
        blur: 0,
        y: '0%',
        x: '0%',
        duration: scrollDuration || 1,
        delay: scrollDelay,
        ease: scrollEase || 'power4.inOut',
      },
      scrollGroup
    );
    animations_list.push(animation);

    const tween = this.addTimeline(animations_list, [el]);
    return tween;
  }

  addTimeline(animations_list, els, group_name = 'section') {
    let tween = gsap.timeline();
    animations_list.forEach((animation, index) => {
      const { scrollGroup } = els[index].dataset;
      tween.add(animation, scrollGroup || group_name);
    });
    return tween;
  }

  add(index) {
    let all_els = document.querySelectorAll('[data-card-fadeup]');
    this.setup(all_els, index);
  }

  refresh() {
    while (this.tweens.length) {
      let tween = this.tweens.pop();
      tween.kill();
      tween = null;
    }
    this.els = null;
    this.reset();
    this.setup();
  }
}
